import { FAIRE_DIRECT_FOI } from "@faire/retailer-visitor-shared/components/App/AppModals/consts";
import { Button } from "@faire/web--source/slate/Button/Button";
import { useCurrentPath } from "@faire/web--source/ui/hooks/useCurrentPath";
import React, { type JSX } from "react";
import { useHistory } from "react-router-dom";

export const OpenFaireDirectFirstOrderIncentiveModalButton = (
  chunks: JSX.Element
) => {
  const history = useHistory();
  const currentPath = useCurrentPath();

  const openFaireDirectFirstOrderIncentiveModal = () => {
    history.push(
      currentPath.append({ show_modal: FAIRE_DIRECT_FOI }).toString()
    );
  };

  return (
    <Button
      variant="tertiary"
      onClick={openFaireDirectFirstOrderIncentiveModal}
    >
      {chunks}
    </Button>
  );
};
